import TokensList from "./list";

export default TokensList;
